module.exports = __webpack_public_path__ + "img/19.ed8eb7e7.svg";